export const useNativeFallback = () => {
    const route = useRoute();
    const isNativeFallback = computed(() => route.path.includes("/no-script-error"));

    return {
        isNativeFallback
    };
};